module.exports = "<app-header [tipoMenu]=\"tipoMenuValue\"></app-header>\n<app-detalhamento-registro></app-detalhamento-registro>\n    "